// extracted by mini-css-extract-plugin
export var drawerContent = "_2r-0";
export var valueBlock = "_2r-1";
export var valueBlockFrom = "_2r-2 _2r-1";
export var valueBlockTo = "_2r-3 _2r-1";